import * as is from 'utilities/is';

const CONSOLE_METHODS = ['log', 'info', 'error', 'warn', 'trace', 'debug'];

export const safeLogPrefix = method => (...args) => {
    if (is.fn(window.console[method])) {
        window.console[method]('hapyak: ', ...args);
    } else if (is.fn(window.console.log)) {
        window.console.log('hapyak: ', ...args);
    }
};

export class Logger {
    constructor() {
        CONSOLE_METHODS.forEach(this.proxyConsole);
    }

    proxyConsole = method => this[method] = this.shouldLog ? safeLogPrefix(method) : noop

    dev = this.shouldLog ? safeLogPrefix('info') : noop

    get shouldLog() {
        if (HAPYAK_ENVIRONMENT === 'production' || HAPYAK_ENVIRONMENT === 'test') {
            return false;
        }

        return true;
    }
}

export const noop = () => {};

export const stubConsole = CONSOLE_METHODS.reduce((reduced, method) => {
    reduced[method] = noop;
    return reduced;
}, {});

export const logger = new Logger();

window.console = window.console || stubConsole;

export const logRemotely = message => {
    if (window.Sentry && is.fn(window.Sentry.captureMessage)) {
        window.Sentry.captureMessage(message);
    }
}